//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import { observer } from "mobx-react-lite";
import Pluralize from "pluralize";
import React from "react";
import { array, object, string } from "yup";
import Select from "../../../components/form-elements/Select";
import { SCHEDULE_DATA } from "../../request-flow/constants";
import CTAButtons from "./CTAButtons";

let initialValue = {
  lessonDays: [],
  lessonTime: "4:00 PM",
  lessonHours: 2,
  lessonDuration: 4,
  lessonUrgency: "",
  lessonPlan: "",
};

let placeholders = {
  lessonDays: {
    label: "Lesson days",
    placeholder: "Select days",
  },
  lessonTime: {
    label: "From what time?",
    placeholder: "Select a time",
  },
  lessonHours: {
    label: "Hours per day?",
    placeholder: "Select hours",
  },
  lessonDuration: {
    label: "For how long?",
    placeholder: "Select duration",
  },
  lessonUrgency: {
    label: "To start how soon?",
    placeholder: "Select start time",
  },
};

let commonProps = ({ name }, { touched, errors }) => ({
  ...placeholders[name],
  isInvalid: touched[name] && errors[name],
  errorMessage: errors[name],
});

export const DurationUrgency = () => {
  const { durationOfLesson, lessonUrgency } = SCHEDULE_DATA;

  return (
    <SimpleGrid columns={[1, 2]} spacing={5}>
      <Field name="lessonDuration">
        {({ field, form }) => (
          <FormControl isInvalid={commonProps(field, form).isInvalid}>
            <FormLabel>{commonProps(field, form).label}</FormLabel>
            <Select
              value={field.value}
              onChange={(value) => form.setFieldValue(field.name, value.value)}
              options={durationOfLesson}
              noOptionsMessage={() => "Select a duration"}
              {...commonProps(field, form)}
            />
            <FormErrorMessage>
              {commonProps(field, form).errorMessage}
            </FormErrorMessage>
          </FormControl>
        )}
      </Field>
      <Field name="lessonUrgency">
        {({ field, form }) => (
          <FormControl isInvalid={commonProps(field, form).isInvalid}>
            <FormLabel>{commonProps(field, form).label}</FormLabel>
            <Select
              value={field.value}
              onChange={(value) => form.setFieldValue(field.name, value.value)}
              options={lessonUrgency}
              noOptionsMessage={() => "Select a start time"}
              {...commonProps(field, form)}
            />
            <FormErrorMessage>
              {commonProps(field, form).errorMessage}
            </FormErrorMessage>
          </FormControl>
        )}
      </Field>
    </SimpleGrid>
  );
};

export const BareLessonScheduleForm = ({ isAdmin = false }) => {
  const {
    daysOfTheWeek,
    hoursOfLesson,
    durationOfLesson,
    hourlyTimes,
    lessonUrgency,
  } = SCHEDULE_DATA;

  let timeOptions = hourlyTimes.map((time) => ({ label: time, value: time }));
  let dayOptions = daysOfTheWeek.map(({ longDay, value }) => ({
    label: longDay,
    value,
  }));
  return (
    <>
      <Field name="lessonDays">
        {({ field, form }) => (
          <FormControl isInvalid={Boolean(commonProps(field, form).isInvalid)}>
            <FormLabel>{commonProps(field, form).label}</FormLabel>

            <CheckboxGroup
              spacing={3}
              {...field}
              size="lg"
              {...commonProps(field, form)}
              defaultValue={field.value}
              onChange={(value) => form.setFieldValue(field.name, value)}
            >
              <SimpleGrid
                templateColumns={["repeat(2, 1fr)", "repeat(3, 1fr)"]}
                spacing={3}
              >
                {dayOptions.map((option) => (
                  <Checkbox
                    key={option.value}
                    isInvalid={Boolean(commonProps(field, form).isInvalid)}
                    size="lg"
                    value={option.value}
                  >
                    <Text ml={1} fontSize="md">
                      {option.label}
                    </Text>
                  </Checkbox>
                ))}
              </SimpleGrid>
            </CheckboxGroup>
            <FormErrorMessage>
              {commonProps(field, form).errorMessage}
            </FormErrorMessage>
          </FormControl>
        )}
      </Field>

      <SimpleGrid columns={[1, 2]} spacing={5}>
        <Field name="lessonTime">
          {({ field, form }) => (
            <FormControl isInvalid={commonProps(field, form).isInvalid}>
              <FormLabel>{commonProps(field, form).label}</FormLabel>
              <Select
                value={field.value}
                onChange={(value) =>
                  form.setFieldValue(field.name, value.value)
                }
                options={timeOptions}
                noOptionsMessage={() => "Select a time"}
                {...commonProps(field, form)}
              />

              <FormErrorMessage>
                {commonProps(field, form).errorMessage}
              </FormErrorMessage>
            </FormControl>
          )}
        </Field>
        <Field name="lessonHours">
          {({ field, form }) => (
            <FormControl isInvalid={commonProps(field, form).isInvalid}>
              <FormLabel>{commonProps(field, form).label}</FormLabel>
              <Select
                value={field.value}
                onChange={(value) =>
                  form.setFieldValue(field.name, value.value)
                }
                options={hoursOfLesson}
                noOptionsMessage={() => "Select a duration"}
                {...commonProps(field, form)}
              />
              <FormErrorMessage>
                {commonProps(field, form).errorMessage}
              </FormErrorMessage>
            </FormControl>
          )}
        </Field>
      </SimpleGrid>
      {!isAdmin && <DurationUrgency />}
    </>
  );
};

export const LessonScheduleFormWithRef: any = React.forwardRef((props, ref) => {
  let {
    value = {},
    onSubmit = () => {},
    onBackClick = () => {},
    loading,
    isAdmin = true,
    ...rest
  }: any = props;

  let validationSchema = object().shape({
    lessonDays: array()
      .of(string())
      .min(1, "Select one day at least")
      .required("Select lesson days"),
    lessonTime: string().required("Select a preferred time"),
    lessonHours: string().required("Select hours per lesson"),
  });

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={{ ...initialValue, ...value }}
      onSubmit={onSubmit}
      ref={ref as any}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Stack spacing="20px">
              <BareLessonScheduleForm isAdmin={isAdmin} />
            </Stack>
          </form>
        );
      }}
    </Formik>
  );
});

type LessonScheduleFormProps = {
  value?: any;
  onSubmit?: any;
  minimumDays: number;
  viewModel?: any;
  onCompleteRequest?: any;
  onBackClick?: any;
  currency?: string;
  submitText?: string;
  priceIsFetched?: boolean;
  generateAmount?: any;
  loading?: boolean;
  teacherOption?: string;
  [key: string]: any;
};

const LessonScheduleForm = observer(
  ({
    value = {},
    onSubmit = () => {},
    minimumDays,
    submitText = "Next: Location",
    viewModel,
    onCompleteRequest = () => {},
    onBackClick,
    currency = "₦",
    priceIsFetched = true,
    generateAmount = (x) => x,
    loading,
    teacherOption,
    ...rest
  }: LessonScheduleFormProps) => {
    let validationSchema = object().shape({
      lessonDays:
        teacherOption === "Specialized teachers"
          ? array()
              .of(string())
              .min(
                minimumDays,
                `Select ${Pluralize(
                  "day",
                  minimumDays,
                  true
                )} at least. 1 day per tutor`
              )
              .required("Select lesson days")
          : array()
              .of(string())
              .min(1, "Select one day at least")
              .required("Select lesson days"),
      lessonTime: string().required("Select a preferred time"),
      lessonHours: string().required("Select hours per lesson"),
      lessonDuration: string().required("Length of lessons?"),
      lessonUrgency: string().required("When to start?"),
    });

    return (
      <Formik
        key={`${viewModel.lessonDays?.length}-${teacherOption}`}
        validationSchema={validationSchema}
        initialValues={{ ...initialValue, ...viewModel.toJSON() }}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Stack spacing="24px">
                <BareLessonScheduleForm />
                <CTAButtons
                  onBackClick={onBackClick}
                  submitText={submitText}
                  loading={loading as boolean}
                />
              </Stack>
            </form>
          );
        }}
      </Formik>
    );
  }
);

export default LessonScheduleForm;
